import styles from './KycModule.module.css';
import { DECISION_ETIQUETA } from './formato';

export function DecisionChip({ decision }: { decision: string }) {
  const clase = decision === 'APPROVED' ? styles.decisionOk
    : decision === 'REJECTED' ? styles.decisionErr
      : decision === 'MANUAL_REVIEW' ? styles.decisionRev : '';
  return <span className={`${styles.chip} ${clase}`}>{DECISION_ETIQUETA[decision] ?? decision}</span>;
}
